import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import React, { useState, useEffect, useMemo } from 'react';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData, fetchPieChartData, fetchDonorChartData, fetchTableData } from './../reduxactions/fundmanagersactions/DashboardActions';
import { useNavigate } from 'react-router-dom';
import { GFNButton } from '../ui/GFNButton';
import './FundDashboard.css';
import { Divider } from 'primereact/divider';


const FundDashboard = () => {
  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchData(uid) as any);
        await dispatch(fetchPieChartData(uid) as any);
        await dispatch(fetchDonorChartData(uid) as any);
        await dispatch(fetchTableData(uid) as any);



      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAsync();
  }, [dispatch]);

  const data = useSelector((state: RootState) => state.funmdashboard.data);
  const piechartData = useSelector((state: RootState) => state.funmdashboard.pieChartData);
  const ManagerchartData = useSelector((state: RootState) => state.funmdashboard.donorChartData);
  const piechartOptions = useSelector((state: RootState) => state.funmdashboard.piechartOptions);
  const ManagerchartOptions = useSelector((state: RootState) => state.funmdashboard.donorChart);
  const donorTableData = useSelector((state: RootState) => state.ddashboard.donorTableData);

  const navigate = useNavigate();

  const Donates = () => {
    const url = `/fundslist`;
    navigate(url);
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/fmdashboard.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  const summary = data?.[0];

  const stats = useMemo(
    () => [
      {
        label: 'Needs',
        value: summary?.needcount,
        icon: 'pi pi-heart-fill',
        className: 'app-stat-card--rose'
      },
      {
        label: 'Donations',
        value: summary?.donations,
        icon: 'pi pi-dollar',
        className: 'app-stat-card--green'
      },
      {
        label: 'Organization',
        value: summary?.org,
        icon: 'pi pi-sitemap',
        className: 'app-stat-card--blue'
      },
      {
        label: 'Donor',
        value: summary?.donor,
        icon: 'pi pi-user',
        className: 'app-stat-card--orange'
      }
    ],
    [summary]
  );
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">

            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Dashboard</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <section className="content">
              {/* {data.map((response: any) =>
                <div className="grid">
                  <div className="col-3">
                    <div className="bg-red">
                      <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-red-200">
                        <div className="flex justify-content-between mb-3">
                          <div>
                            <span className="block text-500 font-medium mb-3 text-900">Needs</span>
                            <div className="text-900 font-medium text-xl">{response.needcount}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-green-200 ">
                      <div className="flex justify-content-between mb-3">
                        <div>
                          <span className="block text-500 font-medium mb-3 text-900">Donations</span>
                          <div className="text-900 font-medium text-xl">{response.donations}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-bluegray-400">
                      <div className="flex justify-content-between mb-3">
                        <div>
                          <span className="block text-500 font-medium mb-3 text-900">Organization</span>
                          <div className="text-900 font-medium text-xl">{response.org}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-bluegray-400">
                      <div className="flex justify-content-between mb-3">
                        <div>
                          <span className="block text-500 font-medium mb-3 text-900">Donor</span>
                          <div className="text-900 font-medium text-xl">{response.donor}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}
              <div className="grid">
                {stats.map((stat) => (
                  <div
                    className="col-12 md:col-6 lg:col-3"
                    key={stat.label}
                  >
                    <div className={`app-stat-card ${stat.className}`}>
                      <div className="app-stat-card__content">
                        <div>
                          <span className="app-stat-card__label">
                            {stat.label}
                          </span>

                          <div className="app-stat-card__value">
                            {stat.value}
                          </div>
                        </div>

                        <span className="app-stat-card__icon">
                          <i
                            className={stat.icon}
                            style={{ fontSize: '3.5rem' }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="grid">

                {/* Organizations Chart */}
                <section className="col-12 lg:col-6">

                  <div className="surface-card shadow-3 border-round-2xl p-3 h-full">

                    <Panel
                      header="Organizations Overview"
                      toggleable
                      className="app-panel border-none"
                    >

                      <div
                        className="flex align-items-center justify-content-center"
                        style={{
                          minHeight: '450px',
                          padding: '1rem'
                        }}
                      >

                        <Chart
                          type="bar"
                          style={{
                            width: '100%',
                            height: '420px'
                          }}
                          data={ManagerchartData}
                          options={ManagerchartOptions}
                        />

                      </div>

                    </Panel>

                  </div>

                </section>

                {/* Donations Chart */}
                <section className="col-12 lg:col-6">

                  <div className="surface-card shadow-3 border-round-2xl p-3 h-full">

                    <Panel
                      header="Donations Overview"
                      toggleable
                      className="app-panel border-none"
                    >

                      <div
                        className="flex align-items-center justify-content-center"
                        style={{
                          minHeight: '450px',
                          padding: '1rem'
                        }}
                      >

                        <Chart
                          type="doughnut"
                          style={{
                            width: '100%',
                            maxWidth: '500px',
                            height: '420px'
                          }}
                          data={piechartData}
                          options={piechartOptions}
                        />

                      </div>

                    </Panel>

                  </div>

                </section>

              </div>

            </section>
            <Panel header="Latest Donations" toggleable className="app-panel">
              <section className="content">
                <div className="app-table-toolbar">
                  <h3 style={{ margin: 0 }}>Latest Donations</h3>
                  <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                  </span>
                </div>
                <DataTable value={donorTableData} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                  <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                  <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                  <Column field="firstname" sortable header="Donar Name"></Column>
                  <Column field="Amount" sortable header="Amount"></Column>
                  <Column field="CreateDate" sortable header="Date"></Column>
                  <Column field="donationStatus" sortable header="Status"></Column>

                </DataTable>
                <div className="flex justify-content-end mt-3">
                  <GFNButton buttonType="primary" label="View All Donations" onClick={Donates} />
                </div>
              </section>
            </Panel>
          </div>
        </div>
      </div>
    </div>

  )
}

export default FundDashboard
